<template>
  <div class="Input">
    <span class="label" :style="{ width: labelWidth || '80px' }" v-if="label">{{
      label
    }}</span>
    <div class="input_box">
      <div class="input_boxcross">
        <input
          v-model="col"
          :placeholder="placeholder"
          type="text"
          v-bind="$attrs"
          :readonly="readonly"
          @input="
            (e) => {
              handleinput(e);
            }
          "
          :disabled="disabled"
          :maxlength="maxlength"
          ref="Field"
        />

        <span class="amountCompany">{{ amountCompany }}</span>
        <van-icon v-show="isDelete" @click="clickDelete" class="cross" name="cross" />
      </div>
      <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'loanAmountInput',
  props: [
    'props',
    'placeholder',
    'type',
    'disabled',
    'value',
    'label',
    'labelWidth',
    'border',
    'prop',
    'max',
    'min',
    'separate',
    'readonly',
    'toUpperCase',
    'amountCompany',
  ],
  data() {
    return {
      col: '',
      errorMessage: '',
      isDelete: false,
    };
  },
  computed: {
    maxlength() {
      return this.max.toString().length;
    },
  },
  watch: {
    readonly: {
      handler(val) {
        // eslint-disable-next-line no-unused-expressions
        !val ? (this.isDelete = false) : '';
      },
      immediate: true,
    },
    col: {
      handler(newVal, oldVal) {
        if (oldVal === undefined) {
          this.col = this.value;
        }
        if (newVal !== '') {
          // eslint-disable-next-line no-unused-expressions
          !this.readonly ? (this.isDelete = true) : '';
        } else {
          this.isDelete = false;
        }

        this.$emit('input', newVal);
      },
      immediate: true,
    },
    value: {
      handler(val) {
        this.col = val;
        this.$emit('input', val);
      },
      deep: true,
    },
    max: {
      handler(val) {
        this.updateState({
          max: val,
        });
      },
      immediate: true,
    },
    min: {
      handler(val) {
        this.updateState({
          min: val,
        });
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations('publicPage', ['updateState']),
    // ...mapActions("publicPage", ["updateState"]),
    handleinput() {
      const { inputVal, regExp } = this.amountRuleJudgment({
        min: this.min,
        max: this.max,
        col: this.col,
      });
      const deleteZero = inputVal.replace(/^0/, '');
      this.col = deleteZero;
      this.$emit('input', deleteZero);
      if (!regExp) {
        this.errorMessage = `${this.min}-${this.max}(万元)正整数`;
      } else {
        this.errorMessage = '';
      }
    },
    // 金额规则判断
    amountRuleJudgment({ max, min, col }) {
      // 正整数
      const inputVal = JSON.parse(JSON.stringify(col)).replace(/[^0-9]/g, '');
      return {
        inputVal,
        // regExp: regExp.test(col),
        regExp: col <= max && col >= min,
      };
    },
    clickDelete() {
      this.col = '';
    },
  },
};
</script>
<style scoped>
.Input {
  display: flex;
  background: #fff;
  padding: 12px 16px;
  position: relative;
}
input {
  width: 70%;
  border: 0;
  font-size: 14px;
  padding: 0;
  margin: 0;
}
.label {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #1c2438;
  display: flex;
  align-items: center;
}
.error-message {
  color: #ee0a24;
  font-size: 12px;
  text-align: left;
}
.input_box {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.input_boxcross {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.cross {
  color: #9e9fa0;
}
.amountCompany {
  font-size: 14px;
  color: #1c2438;
}

</style>
